import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

import CustomerSelector from "./CustomerSelector";
import SessionManager from "./SessionManager";
import ChatWindow from "./ChatWindow";
import CustomerGallery from "./CustomerGallery";

export default function DesignStudio({ apiBase = "/api" }) {
  const [customerId, setCustomerId] = useState(null);
  const [sessionId, setSessionId] = useState(null);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const customer = searchParams.get("customer");
    const session = searchParams.get("session");

    if (customer) setCustomerId(customer);
    if (session) setSessionId(session);
  }, []);

  return (
    <Container fluid className="mt-3">
      <Row>
        {/* LEFT PANEL */}
        <Col md={3}>
          <CustomerSelector
            apiBase={apiBase}
            onSelect={(id) => {
              setCustomerId(id);
              setSessionId(null); // reset session when customer changes
            }}
          />

          <SessionManager
            apiBase={apiBase}
            customerId={customerId}
            onSelectSession={setSessionId}
          />
        </Col>

        {/* CENTER CHAT */}
        <Col md={6}>
          <ChatWindow
            apiBase={apiBase}
            customerId={customerId}
            sessionId={sessionId}
            setSessionId={setSessionId}
          />
        </Col>

        {/* RIGHT GALLERY */}
        <Col md={3}>
          <CustomerGallery apiBase={apiBase} customerId={customerId} />
        </Col>
      </Row>
    </Container>
  );
}
